import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import loginReducer from './slices/loginSlice';
import confirmReducer from './slices/confirmSlice';
import themeReducer from './slices/themeSlice';
import textSearchReducer from './slices/textSearchSlice';
import walletReducer from './slices/walletSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    login: loginReducer,
    confirm: confirmReducer,
    theme: themeReducer,
    textSearch: textSearchReducer,
    wallet: walletReducer,
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 